<div class="xvi-label multiple-label">
  <ul>
    <li *ngFor="let item of dataObs | async" class="label-item" [class]="item.itemClass">
      {{item.label}}: {{ formateValueToObservable(item.value) | async }}
    </li>
  </ul>
</div>
